export default "__VITE_ASSET__DQIlAeDC__"